module.exports = {"id":"210513","name":"Juan Fernando Quintero","rating":"77","photo":"./data/images/photos/1/210513.png","club":{"name":"River Plate","logo":"./data/images/clubs/RiverPlate.png"},"positions":["MOC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JuanFernandoQuintero0.json
// module id = 2212
// module chunks = 0